import { render, staticRenderFns } from "./dangerMasterInfo.vue?vue&type=template&id=5ac283e4"
import script from "./dangerMasterInfo.vue?vue&type=script&lang=js"
export * from "./dangerMasterInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ac283e4')) {
      api.createRecord('5ac283e4', component.options)
    } else {
      api.reload('5ac283e4', component.options)
    }
    module.hot.accept("./dangerMasterInfo.vue?vue&type=template&id=5ac283e4", function () {
      api.rerender('5ac283e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/chm/danger/dangerMasterInfo.vue"
export default component.exports